import { FC } from "react";
import { useTranslation } from "react-i18next";
import { Icon, IconName } from "Components/UI";
import { GetAvatar, ThumbType } from "Utils/generateThumbnail";
import Tooltip from "Components/UI/Tooltip";
import { BtnContainer, Container } from "./styles";

export interface IOnChangePermission {
  ID: string;
  isInvited?: boolean;
  privilege?: number;
  hasPlottingPermission: boolean;
}

interface IItem {
  ID: string;
  isInvited?: boolean;
  isSelf?: boolean;
  username: string;
  userAvatar?: string;
  userAvatarThumb?: string;
  userAvatarThumbType?: ThumbType;
  privileges: number[];
  hasPlottingPermission: boolean;
  loading?: boolean;
  onChange: (values: IOnChangePermission) => void;
}

const buttonsPermissionIcons = ['visualizar', 'download', 'upload', 'editar'];

const Item: FC<IItem> = ({
  ID,
  isInvited,
  isSelf,
  username,
  userAvatar,
  userAvatarThumb,
  userAvatarThumbType,
  privileges,
  hasPlottingPermission,
  loading,
  onChange,
}) => {
  const { t } = useTranslation('editObra');
  const isDisabled = loading || isSelf;
  const buttonsPermission = [
    t('permissions.permViewer'),
    t('permissions.permDownload'),
    t('permissions.permUpload'),
    t('permissions.permEdit'),
  ];
  const changeHasPlottingPermission = () => {
    if (isSelf) return;
    onChange({
      ID,
      isInvited,
      hasPlottingPermission: !hasPlottingPermission,
    });
  };

  const changePermissionLevel = (level: number) => {
    if (isSelf) return;
    if (level !== 0) {
      onChange({
        ID,
        isInvited,
        privilege: level,
        hasPlottingPermission,
      });
    }
  };

  return (
    <Container>
      <div className="avatarContainer">
        <GetAvatar
          name={username}
          shape='circle'
          src={userAvatar}
          thumbSrc={userAvatarThumb}
          thumbType={userAvatarThumbType}
        />
        <span className="userName">
          {username}
        </span>
      </div>
      <div className="actionContainer">
        {buttonsPermission.map((name, i) => (
          <Tooltip title={isSelf ? t('permissions.tooltipSelfDisabled') : name} key={name}>
            <BtnContainer
              hasprivileges={privileges.includes(i)}
              isdisabled={isDisabled}
              onClick={() => isDisabled ? undefined : changePermissionLevel(i)}
            >
              <Icon
                icon={buttonsPermissionIcons[i] as IconName}
                customSize={20}
                className="iconPermissionBtn"
              />
            </BtnContainer>
          </Tooltip>
        ))}
        <Tooltip title={isSelf ? t('permissions.tooltipSelfDisabled') : t('permissions.tooltipPlotting')}>
          <BtnContainer
            hasprivileges={hasPlottingPermission}
            isdisabled={isDisabled}
            onClick={isDisabled ? undefined : changeHasPlottingPermission}
          >
            <Icon
              icon="menuPlotagem"
              customSize={20}
              className="iconPermissionBtn"
            />
          </BtnContainer>
        </Tooltip>
      </div>
    </Container>
  )
}

export default Item;
